export default class BaseApp
{
    
    init()
    {
        //
    }

}